import { useState } from 'react';
import { usePedidos } from '../../../../contexts/Pedidos';
import { FieldDropdown, FieldDropdownVer2 } from '../../../../themes/components/FieldDropdown';
import { Transportadora } from '../../interfaces';
import { useHistory } from 'react-router-dom';
import { compareDatas, mascaraDataDDMMAAAA } from '../../../../util/fieldMasks';
import { DatePickerInput } from "rc-datepicker";
import 'moment/locale/pt-br';
import moment from 'moment';
import $ from 'jquery';
import { useEffectOnce } from 'react-use';
import { useModals } from '../../../../contexts/Modals';
import { Typography } from '@material-ui/core';
import { Button } from '../../../../themes/components/Button';

interface Form {
    setFieldTranportadora2: React.Dispatch<React.SetStateAction<Transportadora | undefined>>,
    setFieldDataEntrega: React.Dispatch<React.SetStateAction<string | undefined>>,
    setFieldFrete: React.Dispatch<React.SetStateAction<string>>,
    fieldTranportadora2: Transportadora | undefined,
    fieldDataEntrega: string | undefined,
    getSelectedFrete: () => string
}

export const FormularioInfoEntrega = (props: Form) => {
    const { tiposFrete, buscarTransportadora } = usePedidos();
    const { setMensagem, setShowModalInfo } = useModals();
    const [loadingTransp2, setLoadingTransp2] = useState<boolean>(false);
    const [listaTransp, setListaTransp] = useState<Transportadora[]>([]);
    const history = useHistory();

    useEffectOnce(() => {
        if (props.fieldDataEntrega !== undefined) {
            let campo = (document.getElementsByClassName("data-form-entrega").item(0) as HTMLInputElement).getElementsByTagName("input").item(0)
            $(function () {
                if (campo !== null) {
                    campo.value = props.fieldDataEntrega!;
                }
            })
        }
    })

    function handleFrete(event: any, option: string, reason: any) {
        if (reason === "reset" && option.trim() !== "") {
            for (let index = 0; index < tiposFrete.length; index++) {
                const element = tiposFrete[index];
                if (element.desc === option) {
                    props.setFieldFrete(element.cod);
                    if (element.cod !== "C") {
                        props.setFieldTranportadora2(undefined);
                    }
                    break;
                }
            }
        }
    }

    function handleChangeTransp2(event: any, option: string, reason: any) {
        async function getTransportadora2() {
            await buscarTransportadora(event.target.value, history)
                .then((res) => {
                    setListaTransp(res);
                    setLoadingTransp2(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaTransp([]);
                        console.log(err);
                        setLoadingTransp2(false);
                    }
                })

        }

        if (reason === "input" && event !== null && event.target.value.trim() !== "") {
            props.setFieldTranportadora2(undefined);
            setLoadingTransp2(true);
            getTransportadora2();
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*", '').exec(option);
            let nomeproduto = option.replace(new RegExp("(.*- )", ''), "");
            if (cod !== null) {
                props.setFieldTranportadora2({ "codtra": cod[0], "nomtra": nomeproduto });
            } else {
                props.setFieldTranportadora2(undefined);
            }
        }

        if (reason === "clear"  || (event !== null && String(event.target.value).trim() === "")){
            props.setFieldTranportadora2(undefined);
        }
    }

    //Atualizando data do campo de texto no formulário de entrega
    function handleDate(jsDate: Date, dateString: string) {
        let dataFormatada = ""
        if (dateString !== "Data inválida"){
            if(compareDatas(jsDate, moment().toDate())){
                dataFormatada = (jsDate.getDate() < 10 ? '0' : '') + jsDate.getDate() + "/" + ((jsDate.getMonth() < 9 ? '0' : '') + String(jsDate.getMonth() + 1)) + "/" + jsDate.getFullYear();
                props.setFieldDataEntrega(dataFormatada);
            }else {
                //props.setFieldDataEntrega("");
                setMensagem(
                    <div className='mensagem-info-modal-loading'>
                        <Typography>A data informada não pode ser menor que a data atual.</Typography>
                        <Button onClick={() => [setShowModalInfo(false), props.setFieldDataEntrega("")]} classBtn={"btn-notifications color-default"}>OK</Button>
                    </div>
                )
                setShowModalInfo(true);
            }
        } else {
            //console.log("digitando data...");
            let campo = (document.getElementsByClassName("data-form-entrega").item(0) as HTMLInputElement).getElementsByTagName("input").item(0)
            let textoCampo: string = ""
            $(function () {
                if (campo !== null) {
                    textoCampo = campo.value;
                }
                if (textoCampo !== "") {
                    let data = mascaraDataDDMMAAAA(textoCampo);
                    $(function () {
                        if (campo !== null) {
                            campo.value = data;
                        }
                    })
                    if (data.length !== 10) {
                        props.setFieldDataEntrega(undefined);
                    }
                } else {
                    //console.log("texto não encontrado no campo");
                    props.setFieldDataEntrega(undefined);
                }
            })
        }
    }

    return (
        <div className="novo-pedido-cabecalho">
            <div className="novo-pedido-form-row">
                <div className="novo-pedido-form-column">
                    <div className="novo-pedido-form-field">
                        <label htmlFor="field-frete">Frete</label>
                        <FieldDropdown
                            value={props.getSelectedFrete()}
                            id="novopedido-combobox-tipo-frete"
                            options={tiposFrete.map(opt => opt.desc)}
                            label={(option: string) => option}
                            onChange={(event, option, reason) => {
                                handleFrete(event, option, reason);
                            }}
                        />
                    </div>
                </div>
                <div className="novo-pedido-form-column">
                    <div className="novo-pedido-form-field">
                        <label htmlFor="field-frete">Previsão Faturamento</label>
                        <DatePickerInput
                            onChange={handleDate}
                            locale='pt-br'
                            displayFormat='DD/MM/YYYY'
                            className='data-form-entrega'
                            minDate={moment().toDate()}
                        />
                    </div>
                </div>
                {props.getSelectedFrete() === "(CIF) Por conta do emitente" ?
                    <div className="novo-pedido-form-column">
                        <div className="novo-pedido-form-field">
                            <label htmlFor="field-transp2">Redespacho</label>
                            <FieldDropdownVer2
                                id="additens-combobox-searchtransp2-pedido"
                                value={props.fieldTranportadora2}
                                options={listaTransp || []}
                                loading={loadingTransp2}
                                select={(option: Transportadora, value: Transportadora) => option.codtra === value.codtra}
                                label={(option: Transportadora) => option.codtra !== undefined ? option.codtra + " - " + option.nomtra : ""}
                                onChange={(event, option, reason) => handleChangeTransp2(event, option, reason)}
                                noOptionsText={"Digite um código ou nome válido"}
                            />
                        </div>
                    </div>
                    :
                    <></>
                }
            </div>
            <div>
            </div>
        </div>
    )
}